import React from "react";
import { RadarElement } from "./radar.js";

export function Results({
  radarValues,
  changeToCompetenceGoalsForm,
  competenceGoalsState,
}) {
  return (
    <section>
      <div className="line"></div>

      <h2>Kompetenskarta</h2>
      {!competenceGoalsState ? (
        <>
          {" "}
          <p className="content-area">
            Figuren nedan illustrerar kompetensen. Titta på mönstret. Vilka
            områden är starkast? Vilka områden har störst utvecklingspotential?
          </p>
          <p className="content-area">
            Du kan nu sätta upp ett kompetensmål för dig själv och jämföra det
            med din nuvarande kompetensnivå. Använd knappen nedan för att börja
            sätta upp mål.
          </p>
          {!competenceGoalsState && (
            <button
              onClick={() => changeToCompetenceGoalsForm()}
              className="submit-button"
            >
              Sätt upp dina kompetensmål
            </button>
          )}
        </>
      ) : (
        <>
          <p className="content-area">
            Den röda färgen representerar den aktuella kompetensen och den blå
            representerar den fastställda målnivån. Titta på mönstren och jämför
            dem. Använd visualiseringen för att fundera över vilka
            kompetensområden som har störst utvecklingspotential. Använd
            observationerna som stöd för planeringen av din egen
            kompetensutveckling.
          </p>
        </>
      )}

      <RadarElement
        values={radarValues}
        competenceGoalsState={competenceGoalsState}
      />
    </section>
  );
}
